import React from 'react';
import { Divider } from '@mui/material';
import ShareableLinkSection from './ShareableLinkSection';
import AccessLinkSection from './AccessLinkSection';
import { useFormikContext } from 'formik';
import { SparkResourceSharePopoverValues } from './SparkResourceSharePopover';
import { DropdownOption } from 'types/common/DropdownOption';
import { ResourceShare } from 'types/Share/ResourceShares';
import CollaboratorSection from './CollaboratorSection';

type SparkResourceShareContentProps = {
  accessLevelDropdownOptions: DropdownOption[];
  sharableLinkShares: ResourceShare[] | undefined;
  resourceTypeID: string;
  resourceID: string;
  accessLevelShares: ResourceShare[];
  onManageClick: () => void;
};

function SparkResourceShareContent({
  accessLevelDropdownOptions,
  sharableLinkShares,
  resourceTypeID,
  resourceID,
  accessLevelShares,
  onManageClick,
}: SparkResourceShareContentProps) {
  const { values } = useFormikContext<SparkResourceSharePopoverValues>();
  const emails = values.individualEmails;

  return (
    <>
      <AccessLinkSection
        accessLevelDropdownOptions={accessLevelDropdownOptions}
      />

      {emails.length === 0 && (
        <>
          <Divider sx={{ width: '100%' }} />
          <ShareableLinkSection
            accessLevelDropdownOptions={accessLevelDropdownOptions}
            resourceShareID={sharableLinkShares?.[0].id}
            resourceTypeID={resourceTypeID}
          />
        </>
      )}
      <Divider sx={{ width: '100%' }} />
      <CollaboratorSection
        onManageClick={onManageClick}
        resourceTypeID={resourceTypeID}
        resourceID={resourceID}
        accessLevelShares={accessLevelShares}
      />

      {/* <SparkFormAutoSubmitter /> */}
    </>
  );
}

export default SparkResourceShareContent;
